import React, { forwardRef } from 'react'

import { IconProps } from './types'

const MenuHorizontal = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.375 9.375L15.625 9.375V10.625H14.375V9.375Z"
        className="fill-foreground-normal"
      />
      <path
        d="M9.375 9.375L10.625 9.375V10.625L9.375 10.625V9.375Z"
        className="fill-foreground-normal"
      />
      <path
        d="M4.375 9.375L5.625 9.375V10.625H4.375L4.375 9.375Z"
        className="fill-foreground-normal"
      />
      <path
        d="M14.375 9.375L15.625 9.375V10.625H14.375V9.375Z"
        className="stroke-foreground-subtle"
        strokeWidth="1.25"
      />
      <path
        d="M9.375 9.375L10.625 9.375V10.625L9.375 10.625V9.375Z"
        className="stroke-foreground-subtle"
        strokeWidth="1.25"
      />
      <path
        d="M4.375 9.375L5.625 9.375V10.625H4.375L4.375 9.375Z"
        className="stroke-foreground-subtle"
        strokeWidth="1.25"
      />
    </svg>
  ),
)
MenuHorizontal.displayName = 'MenuHorizontal'

export default MenuHorizontal
